import { mapGetters } from 'vuex'
import bigDataLog from '@/utils/bigDataLog'
import {
    SRM,
    TWO,
    COMPANY,
    PERSON,
    FOUR,
    FORTY_FIVE_HUNDRED,
    CAR_OWNER_TYPE,
    AUDIT_STATUS,
} from '../../../../../../constant/constant.js'
import { carTypeSrmAdvanceConfig } from '../../../../../../constant/advanceConfig'
import { uploadList } from './uploadListConfig.js'
import { vehiclePublicForm, vehicleRules, bringOutFieldsConfig } from './formdataAndRules.js'
import registerUpload from '../../../../../../components/upload/Index.vue'
import mSelect from '../../../../../../components/Select.vue'
import preview from '../../../../../../components/viewAttachment.vue'
import advance from '../../../../../../components/bulletFrame/otpAdvance/index.vue'
import NewUploadVersion from './newUploadVersion/Index.vue'
import {
    addVehicle,
    addVehiclePrivile,
    editVehicle,
    editVehiclePrivile,
    submitCopyVehicle,
    revokeApprove,
} from '../../../../../../api/register/vehicle.js'
import { verifyDate } from '../../../../../../utils/common.js'
import { dictWithUrl } from '@/components/lots/api'
import addOrEditDialogMethods from './addOrEditDialogMethods.js'
// const AUTH_CAR_OWNER = '04000099'; // TODO: 暂时注释，后面恢复
export default {
    name: 'add-or-edit-vehicle-dialog',
    components: { mSelect, registerUpload, preview, advance, NewUploadVersion },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierName: '',
                    propertyNature: '',
                }
            },
        },
        openAddOrEditDialog: {
            type: Boolean,
            default() {
                return false
            },
        },
        addOrEdit: {
            type: Boolean,
            default() {
                return false
            },
        },
        id: {
            type: String,
            default() {
                return {}
            },
        },
        copy: {
            type: Boolean,
            default() {
                return false
            },
        },
        approve: {
            type: Boolean,
            default() {
                return false
            },
        },
        manage: {
            type: Boolean,
            default() {
                return false
            },
        },
        supplierCode: {
            type: String,
            default() {
                return ''
            },
        },
        supplierName: {
            type: String,
            default() {
                return ''
            },
        },
        propertyNature: {
            type: String,
            default() {
                return ''
            },
        },
        businessType: {
            type: String,
            default() {
                return ''
            },
        },
        principalName: {
            type: String,
            default() {
                return ''
            },
        },
        isSupplier: {
            type: Boolean,
            default() {
                return !!this.$store.state.supplier
            },
        },
        approvalStatus: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        return {
            // // 是否显示新版本页面（控制新旧版切换），旧版已弃用，因此改变量弃用
            // isNewUploadVersion: true,
            // 是否主体性质为法人
            isLegalPersonSupplier: false,
            path: process.env.BASE_URL,
            loading: false,
            sessionStorage,
            approveInfo: {
                approvalUserName: '', // 审批人(分公司)
                approvalStatus: '', // 审批进度
                approvalStatusText: '', // 审批进度文本
                commitTime: '', // 提交时间
                approvalOpinion: '', // 驳回理由
                approvalTime: '', // 提交时间
                commitUserCode: '',
                auditTypeText: '', // 审批类型文本
                createSystemSourceText: '', // 创建渠道文本
                headquartersApprovalName: '', // 审批人(总部)
                fdId: '', // MIP审批流程编码
                approvalModeText: '', // 审批模式
                businessTypeText: '', // 业务类型
            },
            dict: {},
            attachmentList: [],
            allAttachmentList: [],
            lengthOptions: [],
            closeOnClickModal: false,
            params: {
                name: '司机',
                value: 'commonDriver',
                unfold: true,
                advanceConfig: [
                    { prop: 'driverName', value: '司机姓名' },
                    { prop: 'driverCode', value: '司机编码' },
                ],
                tableConfig: [
                    { prop: 'driverCode', value: '司机编码' },
                    { prop: 'driverName', value: '司机姓名' },
                    { prop: 'phoneNo', value: '手机' },
                ],
                advanceUrl: '',
                type: 'advance',
                prefix: SRM,
                cbParams: [
                    'driverCode#commonDriverCode',
                    'driverName#commonDriver',
                    'phoneNo#commonDriverPhone',
                    'delegateFileName#delegateFileName',
                    'delegateNo#delegateNo',
                    'delegateFileUrl#delegateFileUrl',
                    'delegateEndTime#delegateEndTime',
                ],
            },
            advanceOriginUrl: '/supplierDriverInfos/simple/Drivers/',
            paramsLength: {
                ...carTypeSrmAdvanceConfig,
                width: '950px',
                unfold: true,
                tableConfig: [
                    { prop: 'cdegCode', value: '车型代码' },
                    { prop: 'actualVechile', value: '实际车型' },
                    { prop: 'vehicleBigType', value: '标准车型' },
                    { prop: 'cdegModelTypeName', value: '车辆类型' },
                    { prop: 'carLengthRange', value: '长度范围' },
                    {
                        prop: 'flyWingFlag',
                        value: '是否飞翼车',
                        type: 'select',
                        options: {
                            Y: '是',
                            N: '否'
                        }
                    },
                    { prop: 'cdegInteriorLength', value: '内部长度(m)' },
                    { prop: 'cdegInteriorWidth', value: '内部宽度(m)' },
                    { prop: 'cdegInteriorHeight', value: '内部高度(m)' },
                    { prop: 'cdegMaxVolume', value: '最大装载体积(m³)' },
                    { prop: 'cdegMaxWeight', value: '最大装载重量(kg)' },
                    { prop: 'axlesNum', value: '轴数(个)' },
                ],
                cbParams: [
                    'cdegCode#length',
                    'actualVechile#lengthNameCn',
                    'cdegInteriorLength#lengthInteriorLength',
                    'cdegInteriorWidth#lengthInteriorWidth',
                    'cdegInteriorHeight#lengthInteriorHeight',
                    'cdegLengthKey#fuyouLengthKey',
                    'cdegMaxVolume#lengthMaxVolume',
                    'cdegMaxWeight#lengthMaxWeight',
                    'cdegModelType#vehicleType',
                ],
                configuration: {
                    defaultProp: 'cdegCode,actualVechile,vehicleBigType,cdegModelTypeName,carLengthRange,cdegMaxVolume,cdegMaxWeight,axlesNum',
                    defaultLabel: '车型代码,实际车型,标准车型,车辆类型,长度范围,最大装载体积(m³),最大装载重量(kg),轴数(个)',
                    moduleCode: 'workbench-vehicle-modify-carType-mc',
                    subjectType: 'workbench-vehicle-modify-carType'
                },
            },
            uploadList,
            rowData: {},
            attachmentShow: false,
            uploadDisplayType: 'icon',
            title: '新增',
            allow: false,
            form: JSON.parse(JSON.stringify(vehiclePublicForm)),
            rules: vehicleRules,
            imgSrcPathObj: {},
            ocrData: {
                // OCR 返回的数据信息
                licensePlateNo: null,
                carOwner: null,
            },
            showBottomShadow: true, // 底部灰色背景显示隐藏
            scrollWrapELe: null, // 滚动事件需要的dom
            scrollViewEle: null, // 滚动事件需要的dom
            formDiff: false,
        }
    },
    methods: {
        ...addOrEditDialogMethods,
        hasDiff(v){
            this.formDiff = v
        },
        showpopover(example) {
            // getExample(example).then(res => {
            //     const blob = new Blob([res], { type: 'text/plain' });
            //     this.$set(this.imgSrcPathObj, example, URL.createObjectURL(blob));
            // });
            const img = require(`./newUploadVersion/example/${example}`)
            this.$set(this.imgSrcPathObj, example, img)
        },
        handleRevoke() {
            this.$confirm('是否确定撤回？', '撤回确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                revokeApprove(this.id).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('撤回成功！')
                        this.$emit('refresh')
                        this.closeDialog()
                    }
                })
            })
        },
        view(data) {
            if (this.form[data.fileTemUrl] || this.form[data.fileUrl]) {
                this.rowData = {
                    downUrl: this.form[data.fileTemUrl] || this.form[data.fileUrl],
                    fileName: this.form[data.fileName],
                    fileId: this.form[data.fileId],
                }
                this.attachmentList = this.allAttachmentList
                this.attachmentShow = true
            } else {
                switch (data.fileUrl) {
                    case uploadList[0].fileUrl:
                        this.$message.warning('请上传行驶证正副面')
                        break
                    case uploadList[1].fileUrl:
                        this.$message.warning('请上传行驶证年审页')
                        break
                    case uploadList[2].fileUrl:
                        this.$message.warning('请上传道路运输证')
                        break
                    case uploadList[3].fileUrl:
                        this.$message.warning('请上传挂靠证明')
                        break
                    case uploadList[4].fileUrl:
                        this.$message.warning('请上传车辆照片')
                        break
                    case uploadList[5].fileUrl:
                        this.$message.warning('请上传强险')
                        break
                    case uploadList[6].fileUrl:
                        this.$message.warning('请上传商业保险')
                        break
                }
            }
        },
        getVehicleType(data) {
            this.$set(this.form, 'vehicleType', data)
        },
        getMainVehicleType(data) {
            this.$set(this.form, 'mainVehicleType', data)
        },
        getCarOwnerType(data) {
            this.$set(this.form, 'carOwnerType', data)
        },
        getEnergyType(data) {
            this.$set(this.form, 'energyType', data)
        },
        getLicensePlateColor(data) {
            this.$set(this.form, 'licensePlateColor', data)
        },
        closeDialog() {
            this.$emit('update:copy', false)
            this.$emit('closeDialog', false)
        },
        dialogClosed() {
            this.dealWithNewUploadVersionPageLogic()
        },
        /** 提交完毕后，把父组件的标志位都复原 **/
        handleRecover() {
            this.$message.success('保存成功！')
            this.$emit('update:addOrEdit', false)
            this.$emit('update:copy', false)
            this.$emit('confirmDialog', false)
            this.allow = false
            this.loading = false
            this.dealWithNewUploadVersionPageLogic()
        },
        handleSetLoading() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 3000)
        },
        // 旧版提交
        confirmDialog() {
            // 提交， needExamine 是否需要审批
            this.handleVerify().then(needExamine => {
                if (this.allow) {
                    const isSupplier = this.$store.state.supplier
                    const supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode
                    this.form.supplierCode = supplierCode
                    if (this.propertyNature === PERSON && this.form.carOwnerType === CAR_OWNER_TYPE['TEMPORARY']) {
                        this.$message.warning('个体物流供应商车辆归属不能为临时!')
                        return
                    }
                    this.handleSetLoading()
                    if (this.id && !this.copy) {
                        const editApi = needExamine ? editVehicle : editVehiclePrivile
                        // 编辑提交
                        editApi(JSON.stringify(this.form)).then(res => {
                            if (res && res.code === '0') {
                                if (res.msg && res.msg.toLowerCase() !== 'success') {
                                    this.$message.warning(res.errMsg)
                                } else {
                                    this.handleRecover()
                                }
                            }
                        })
                        return
                    }
                    if (this.id && this.copy) {
                        // copy提交
                        submitCopyVehicle(JSON.stringify(this.form)).then(res => {
                            if (res && res.code === '0') {
                                if (res.msg && res.msg.toLowerCase() !== 'success') {
                                    this.$message.warning(res.errMsg)
                                } else {
                                    this.handleRecover()
                                }
                            }
                        })
                        return
                    }
                    if (!this.id) {
                        // 新增提交
                        const addApi = needExamine ? addVehicle : addVehiclePrivile
                        addApi(JSON.stringify(this.form)).then(res => {
                            if (res && res.code === '0') {
                                if (res.msg && res.msg.toLowerCase() !== 'success') {
                                    this.$message.warning(res.errMsg)
                                } else {
                                    this.handleRecover()
                                }
                            }
                        })
                    }
                }
            })
            bigDataLog.sendDetailMessageByKey('bigData-btn-v-submitOld')
        },
        handleVerify() {
            return new Promise((resolve, reject) => {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.allow = true
                        // 个体 需要走需审批的新增编辑接口
                        if (!this.isLegalPersonSupplier) {
                            resolve(true)
                        } else if (
                            this.isLegalPersonSupplier &&
                            this.approvalStatus &&
                            this.approvalStatus !== AUDIT_STATUS.ADOPT
                        ) {
                            resolve(true)
                        } else if (
                            !this.copy &&
                            (this.form.carOwner !== this.ocrData.carOwner ||
                                this.form.licensePlateNo !== this.ocrData.licensePlateNo)
                        ) {
                            this.$confirm('您修改了“车牌号、车辆所有人”信息，需提交审批', '提示', {
                                confirmButtonText: '提交审批',
                                cancelButtonText: '取消',
                                type: 'info',
                            })
                                .then(() => {
                                    resolve(true)
                                })
                                .catch(() => {
                                    reject(new Error('取消审批'))
                                })
                        } else {
                            resolve(false)
                        }
                    } else {
                        this.allow = false
                        this.$message.warning('请注意填写信息是否完整且正确')
                        reject(new Error('校验失败'))
                    }
                })
            })
        },
        handleCheckSuccess() {
            this.allow = false
            this.$emit('update:addOrEdit', false)
        },
        judgeOr(a, b) {
            return a || b
        },
        judgeAnd(a, b) {
            return a && b
        },
        getCommonDriver(data) {
            this.$set(this.form, 'commonDriverCode', data.commonDriverCode)
            this.$set(this.form, 'commonDriver', data.commonDriver)
            this.$set(this.form, 'commonDriverPhone', data.commonDriverPhone)
            this.$set(this.form, 'delegateNo', data.delegateNo)
        },
        getLength(data) {
            this.$set(this.form, 'length', data.length)
            this.$set(this.form, 'lengthNameCn', data.lengthNameCn)
            this.$set(this.form, 'fuyouLengthKey', data.fuyouLengthKey)
            this.$set(this.form, 'vehicleType', data.vehicleType)
        },
        uploadSuccess(data) {
            const name = data.flag.split('#')[0]
            const url = data.flag.split('#')[1]
            const id = data.flag.split('#')[2]
            const temUrl = url.replace('Url', 'TemUrl')
            if (name === 'carDrivingFileName') {
                // 上传行驶证到OCR带出数据
                if (!this.id) {
                    this.$refs['form'].resetFields()
                } // 新增时上传行驶证，输入框都重置，带出新数据
                const info = data.data.ocrResult
                this.$set(this.form, name, data.data.ossResult.localFileName)
                this.$set(this.form, url, data.data.ossResult.downUrl)
                this.$set(this.form, temUrl, data.data.ossResult.downUrl)
                this.$set(this.form, id, data.data.ossResult.id)
                this.handleGetAllAttachmentList()
                if (!info) {
                    this.$message.warning('行驶证相片真实性或清晰度欠佳，若条件允许，建议重新上传')
                    return
                }
                // 根据ocr识别带出信息，同时：系统检测到是否已经有该车辆，会把已有车辆信息带出
                this.handleBringOutData(info)
                this.handleGetAllAttachmentList()
                if (
                    [
                        !info.mainPlateNum,
                        !info.emptyWeight,
                        !info.totalWeight,
                        !info.loadQuality,
                        !info.mainVehicleType,
                    ].includes(true)
                ) {
                    this.$message.warning('行驶证相片真实性或清晰度欠佳，若条件允许，建议重新上传')
                }
            } else {
                // 上传到oss
                this.$set(this.form, name, data.data.data.localFileName)
                this.$set(this.form, url, data.data.data.downUrl)
                this.$set(this.form, temUrl, data.data.data.downUrl)
                this.$set(this.form, id, data.data.data.id)
                this.handleGetAllAttachmentList()
            }
        },
        handleBringOutData(info) {
            if (!this.id) {
                this.form[bringOutFieldsConfig[0].field] = info.mainPlateNum
            } // 编辑状态不修改了<车牌号>
            bringOutFieldsConfig.forEach((e, i) => {
                if (i) {
                    switch (e.type) {
                        case 'text':
                            this.form[e.field] = info[e.field] || ''
                            break
                        case 'weight':
                            this.form[e.field] = info[e.infoField] ? info[e.infoField].replace('kg', '') : ''
                            break
                        case 'date':
                            this.form[e.field] = verifyDate(info[e.field])
                            break
                    }
                }
            })
            this.setOcrData({ carOwner: info.carOwner, licensePlateNo: info.mainPlateNum })
        },
        setOcrData(data) {
            this.ocrData.licensePlateNo = data.licensePlateNo || null
            this.ocrData.carOwner = data.carOwner || null
        },
        handleGetAllAttachmentList() {
            const list = []
            const urlList = [
                'carDrivingFileTemUrl',
                'carDrivingBottomFileTemUrl',
                'roadTransportFileTemUrl',
                'affiliatedFileTemUrl',
                'photosVehicleFileTemUrl',
                'trafficInsuranceFileTemUrl',
                'businessInsuranceFileTemUrl',
            ]
            urlList.forEach(e => {
                list.push(this.form[e])
            })
            this.allAttachmentList = list.filter(item => {
                if (item) return item
            })
        },
        scrollEvent() {
            if (!this.scrollWrapELe || !this.scrollViewEle) {
                return false
            }
            // 减7像素是为了兼容页面缩放后的效果
            this.showBottomShadow
                = this.scrollWrapELe.scrollTop + this.scrollWrapELe.offsetHeight - 7 < this.scrollViewEle.offsetHeight
        },
        addScrollEvent() {
            this.scrollWrapELe = this.$refs.scrollbar.wrap
            this.scrollViewEle = document.querySelector('.register-vehicle-add-or-edit-dialog .el-scrollbar__view')
            this.scrollWrapELe.addEventListener('scroll', this.scrollEvent, false)
        },
        removeScrollEvent() {
            this.scrollWrapELe.removeEventListener('scroll', this.scrollEvent)
        },
    },
    computed: {
        ...mapGetters(['btnPermissions']),
        country() {
            return this.form.countryCode
        },
        province() {
            return this.form.provinceCode
        },
        city() {
            return this.form.cityCode
        },
        totalWeight() {
            return this.form.totalWeight
        },
        carOwnerType() {
            return this.form.carOwnerType
        },
        supplierCode_() {
            return this.supplierCode
        },
        carOwnerDisabled() {
            // 复制 || 审批 || 无车辆信息-特权-车辆所有人非置灰权限
            // return this.copy || this.approve || !this.btnPermissions.includes(AUTH_CAR_OWNER); // TODO: 暂时注释，后面恢复
            return this.copy || this.approve
        },
    },
    watch: {
        openAddOrEditDialog(val) {
            if (val) {
                this.dealWithOpenLogic()
                this.$nextTick(() => {
                    this.addScrollEvent()
                })
            } else {
                this.removeScrollEvent()
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
            }
        },
        propertyNature: {
            handler(nVal) {
                let boole = false
                const fields = [
                    'mainUserCharacter',
                    'mainVin',
                    'carDrivingAuthority',
                    'mainRegisterDate',
                    'mainIssueDate',
                ]
                if (nVal === PERSON) {
                    boole = true
                }
                fields.forEach(e => {
                    this.rules[e][0].required = boole
                })
                this.rules.carDrivingBottomFileName[0].required = nVal !== COMPANY
            },
            immediate: true,
        },
        supplierCode_: {
            handler(nVal) {
                if (nVal) {
                    this.params.advanceUrl = this.advanceOriginUrl + nVal
                }
            },
            immediate: true,
        },
        supplierCode: {
            handler(nVal) {
                if (nVal) {
                    this.$set(this.form, 'supplierCode', nVal)
                }
            },
            immediate: true,
        },
        totalWeight(nVal) {
            // 车重超过4500KG, 道路运输证必填,道路运输证号必填
            let boole = false
            const fields = ['roadTransportFileName', 'businessName', 'roadTransportEndTime', 'roadTransportNo']
            if (Number(nVal) >= FORTY_FIVE_HUNDRED) {
                boole = true
            }
            fields.forEach(e => {
                this.rules[e][0].required = boole
            })
        },
        carOwnerType(nVal) {
            // 合作、租赁时必填
            let boole = false
            const fields = ['affiliatedFileName', 'affiliatedEndTime']
            if (this.judgeOr(nVal === TWO, nVal === FOUR)) {
                boole = true
            }
            fields.forEach(e => {
                this.rules[e][0].required = boole
            })
        },
    },
    mounted() {
        dictWithUrl(
            'SRM_AUDIT_STATUS,SRM_REGISTER_SOURCE,SRM_CAR_AUDIT_TYPE,SRM_DRIVER_CAR_APPROVAL_MODE,SRM_BUSYNESS_TYPE_BACKGROUND',
        ).then(res => {
            this.dict = res.data
        })
    },
}
